import { ReactNode } from "react";
import "./downloads.css"
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function Alp(): ReactNode {
    const { t } = useTranslation(['alp', 'base']);

    return (
        <div className='max-width text-page-padding'>
            <div className='mission-download'>
                <div className='mp-logo'>
                    <img src="/image/ALP.png" alt="" />
                </div>
                <div>
                    <div className='heading'>{t('header')}</div>
                    <div className='text'>
                        <p>{t('string_1')}</p>
                    </div>
                </div>
                <div className='download-buttons'>
                    <div>{t('Download', { ns: 'base' })}:</div>
                    <Button variant='success' href='https://disk.yandex.ru/d/lsSntR_f5Adh2g' target='_blank'>Windows</Button>
                </div>
            </div>
        </div>
    )
}

export default Alp;